//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as d3 from "d3";

export default {
  name: "HorizontalBarsChart",
  props: [
    "id",
    "disableKey",
    "chartWidth",
    "chartHeight",
    "mainColor",
    "secondaryColor",
    "data",
    "margin",
    "mainGraphKey",
    "secondaryGraphKey",
    "valueLabel",
    "unitLabel",
    "showBackArrow",
    "isLoading",
    "fullWidht"
  ],
  mounted: function () {
    this.renderChart();
  },
  computed: {
    mainData: function () {
      return this.data.mainData;
    },
    secondaryData: function () {
      return this.data.secondaryData;
    },
  },
  watch: {
    data: {
      deep: true,
      handler: function () {
        this.renderChart();
      },
    },
    chartWidth: {
      immediate: true,
      handler: function () {
        this.renderChart();
      },
    },
    chartHeight: {
      immediate: true,
      handler: function () {
        this.renderChart();
      },
    },
  },
  methods: {
    // FIXME
    // Make the chart responsive somehow.
    // Delete the casts.
    renderChart: function () {
      d3.selectAll(`#${this.id} > *`).remove();
      var width = Number(this.chartWidth);
      var height = Number(this.chartHeight);

      var margin = {
        top: Number(this.margin.top),
        right: Number(this.margin.right),
        bottom: Number(this.margin.bottom),
        left: Number(this.margin.left),
      };

      var x = d3
        .scaleLinear()
        .domain([
          0,
          d3.max(
            this.mainData.concat(this.secondaryData ? this.secondaryData : []),
            (d) => d.value
          ) * 1.1,
        ])
        .nice()
        .range([margin.left, width - margin.right]);

      var y = d3
        .scaleBand()
        .domain(
          d3.range(
            d3.max([
              this.mainData.length,
              this.secondaryData ? this.secondaryData.length : 0,
            ])
          )
        )
        .rangeRound([margin.top, height - margin.bottom])
        .padding(0.1);

      var xAxis = (g) =>
        g
          .attr("transform", `translate(0,${height - margin.bottom})`)
          .call(d3.axisBottom(x).ticks(width / 80, null));

      var yAxis = (g) =>
        g.attr("transform", `translate(${margin.left},0)`).call(
          d3
            .axisLeft(y)
            .tickFormat((i) => this.secondaryData[i] ? this.secondaryData[i].label : this.mainData[i].label)
            .tickSizeOuter(0)
        );

      var xGrid = d3
        .axisBottom(x)
        .ticks(width / 80, null)
        .tickSize(this.chartHeight)
        .tickFormat("");

      var svg = d3
        .select(this.$refs.horizontalBarsChart)
        .attr("width", width)
        .attr("height", height);

      svg.append("g").attr("class", "grid").call(xGrid);

      //Main Rectangle
      svg
        .append("g")
        .attr("fill", this.mainColor)
        .attr("class", "graph-rectangle")
        .selectAll("rect")
        .data(this.mainData)
        .join("rect")
        .on("click", (_e, data) => {
          this.$emit("selected-data", { direction: "down", data });
        })
        .on("contextmenu", (e, data) => {
          e.preventDefault();
          this.$emit("selected-data", { direction: "up", data });
        })
        .transition()
        .attr("x", x(0))
        .attr("y", (d, i) => y(i))
        .attr("width", (d) => x(d.value) - x(0))
        .attr("height", this.secondaryData ? y.bandwidth() / 2 : y.bandwidth())
        .duration(0);

      //Secondary Rectangle
      if (this.secondaryData) {
        svg
          .append("g")
          .attr("fill", this.secondaryColor)
          .attr("class", "graph-rectangle")
          .selectAll("rect")
          .data(this.secondaryData)
          .join("rect")
          .on("click", (_e, data) => {
            this.$emit("selected-data", { direction: "down", data });
          })
          .on("contextmenu", (e, data) => {
            e.preventDefault();
            this.$emit("selected-data", { direction: "up", data });
          })
          .attr("y", (d, i) => y(i) + y.bandwidth() / 2)
          .transition()
          .attr("x", x(0))
          .attr("width", (d) => x(d.value) - x(0))
          .attr("height", y.bandwidth() / 2)
          .duration(0);
      }

      svg.append("g").call(xAxis);

      svg.append("g").call(yAxis);

      //Graph Keys
      if (!this.disableKey) {
        if (this.mainGraphKey) {
          svg
            .append("circle")
            .attr("cx", 15)
            .attr("cy", 9)
            .attr("r", 6)
            .style("fill", this.mainColor);
          svg
            .append("text")
            .attr("class", "graph-key")
            .attr("x", 25)
            .attr("y", 10)
            .text(this.mainGraphKey)
            .style("font-size", "15px")
            .attr("alignment-baseline", "middle");
        }
        if (this.secondaryGraphKey) {
          svg
            .append("circle")
            .attr("cx", 15)
            .attr("cy", 34)
            .attr("r", 6)
            .style("fill", this.secondaryColor);
          svg
            .append("text")
            .attr("class", "graph-key")
            .attr("x", 25)
            .attr("y", 35)
            .text(this.secondaryGraphKey)
            .style("font-size", "15px")
            .attr("alignment-baseline", "middle");
        }
      }

      // var backArrow = svg.append("defs").append("g").attr("id", "back-arrow");

      // if (this.showBackArrow) {
      //   backArrow
      //     .append("path")
      //     .attr(
      //       "d",
      //       "M38,52a2,2,0,0,1-1.41-.59l-24-24a2,2,0,0,1,0-2.82l24-24a2,2,0,0,1,2.82,0,2,2,0,0,1,0,2.82L16.83,26,39.41,48.59A2,2,0,0,1,38,52Z"
      //     );
      //   backArrow
      //     .append("rect")
      //     .attr("y", 72.72)
      //     .attr("width", 5)
      //     .attr("height", 5);

      //   svg
      //     .append("g")
      //     .append("use")
      //     .attr("xlink:href", "#back-arrow")
      //     .on("click", (_e) => {
      //       this.$emit("clicked-hierarchy", {
      //         direction: "up",
      //         data: this.mainData[0],
      //       });

      //       horizontalGraphTooltip.style("opacity", "0");
      //       _e.stopPropagation();
      //     });
      // }
      // var horizontalGraphTooltip = d3
      //   .select("#horizontalGraph")
      //   .append("div")
      //   .attr("class", "tool-tip");
      // svg
      //   .selectAll("rect")
      //   .on("mousemove", (e, data) => {
      //     horizontalGraphTooltip.style("left", e.clientX + 10 + "px");
      //     horizontalGraphTooltip.style("top", e.clientY - 20 + "px");
      //     horizontalGraphTooltip.style("opacity", "1");
      //     horizontalGraphTooltip.html(
      //       "<div>" +
      //       this.valueLabel +
      //       ": " +
      //       d3.format(".3s")(data.value) +
      //       " " +
      //       this.unitLabel +
      //       "</div>"
      //     );
      //   })
      //   .on("mouseout", function () {
      //     horizontalGraphTooltip.style("opacity", "0");
      //   });
      svg
        .selectAll("rect")
        .on("mousemove", function (e, data) {
          this.$emit("hovered-vertical-data", {
            valueLabel: this.valueLabel,
            dataValue: d3.format(".3s")(data.value),
            unitLabel: this.unitLabel,
          });
        }.bind(this))
        .on("mouseout", function () {
          this.$emit("hovered-vertical-data", {
            valueLabel: "",
            dataValue: "",
            unitLabel: "",
          });
        }.bind(this));

    },
  },
};
